module.exports = __webpack_public_path__ + "img/default_image.3087fc71.png";